import { defineField, defineType } from 'sanity';

export default defineType({
	name: 'siteSettings',
	title: 'Site Settings',
	type: 'document',
	fields: [
		defineField({
			name: 'bookingNoticeActive',
			title: 'Booking Notice Active',
			type: 'boolean',
			description: 'Enable to show the booking notice banner across the site.',
			initialValue: false,
		}),
		defineField({
			name: 'bookingNoticeTitle',
			title: 'Booking Notice Title',
			type: 'string',
			description: 'The title for the booking notice dialog.',
			initialValue: 'Important Notice',
		}),
		defineField({
			name: 'bookingNoticeText',
			title: 'Booking Notice Text',
			type: 'text',
			description: 'The text to display in the booking notice banner.',
		}),
	],
});
